<template>
  <div class="flex flex-col lg:flex-row flex-wrap gap-3 mb-5">
    <support-program-pathway-card
      v-if="supportProgram.pathway"
      :pathway-step-count="supportProgram.pathway.steps_count"
      class="flex flex-2"
      @click="pathway"
    />
    <div class="flex flex-row flex-wrap flex-1 gap-3">
      <statistic-card
        :value="supportProgram.statistics.excluded.intersection + supportProgram.statistics.included.intersection"
        :label="'Patients concernés dans ma pharmacie'"
        class="flex flex-1"
        :style="{
          'flexBasis': '400px'
        }"
        @click="patients"
      />
      <statistic-card
        v-if="!!program.attachments_count"
        :label="'Ressources et informations à lire'"
        class="flex flex-1"
        :style="{
          'flexBasis': '400px'
        }"
        @click="attachments"
      >
        <template #icon>
          <Book
            :size="40"
            class="fill-primary"
          />
        </template>
      </statistic-card>
    </div>
  </div>
</template>

<script lang="ts" setup>
import StatisticCard from '@/program/components/statistic-card/StatisticCard.vue';
import SupportProgramPathwayCard from '@/program/components/support-program/SupportProgramPathwayCard.vue';
import Book from '@/core/components/icons/Book.vue';
import {Program, SupportProgram} from "@/program/interfaces/Program";
import {useRouter} from "vue-router";

const router = useRouter();
const {program, supportProgram} = defineProps<{
    program: Program;
    supportProgram: SupportProgram;
}>();

/**
 * Redirect to program patients list
 */
const patients = () => {
    router.push({
        name: 'program.detail.consumers',
        params: {
            programId: program.id,
        },
        query: {
            programmableId: program.programmable_id,
            programType: program.programmable_type
        }
    });
};

/**
 * Redirect to program attachments list
 */
const attachments = () => {
    if (program.attachments_count) {
        router.push({
            name: 'program.detail.attachments',
            params: {
                programId: program.id
            }
        });
    }
};

/**
 * Redirect to program pathway
 */
const pathway = () => {
    router.push({
        name: 'program.detail.pathway',
        params: {
            supportProgramId: program.programmable_id
        }
    });
};
</script>
